import Vue from 'vue';
import Router from 'vue-router';

// Containers
const TheContainer = () => import('@/containers/TheContainer');
const Dashboard = () => import('@/views/Dashboard/dashboard');

const ViewPaySlips = () => import('@/views/MyPaySlips/myPaySlips');
const EmployeeDetail = () => import('@/views/EmployeeDetail/employeeDetail');
const Reimbursement = () => import('@/views/Reimbursement/reimbursement');
const AddEmployees = () => import('@/views/AddEmployees/addEmployees');
const WalletConnection = () =>
    import('@/views/WalletConnection/walletConnection');
const ProfileScreen = () => import('@/views/ProfileScreen/profileScreen');

Vue.use(Router);

export default new Router({
    mode: 'history',
    linkActiveClass: 'open active',
    scrollBehavior: () => ({ y: 0 }),
    routes: [
        {
            path: '/',
            redirect: '/wallet_connection',
            name: '',
            component: {
                render(c) {
                    return c('router-view');
                }
            },
            children: [
                {
                    path: 'wallet_connection',
                    name: 'Wallet',
                    component: WalletConnection
                }
            ]
        },
        {
            path: '/',
            redirect: '/dashboard',
            name: '',
            component: TheContainer,
            children: [
                {
                    path: 'dashboard',
                    name: 'Dashboard',
                    component: Dashboard
                },
                {
                    path: 'viewPaySlips',
                    name: 'My PaySlips',
                    component: ViewPaySlips
                },
                {
                    path: 'employeeDetail',
                    name: 'Employee Detail',
                    component: EmployeeDetail
                },
                {
                    path: 'reimbursement',
                    name: 'Reimbursement',
                    component: Reimbursement
                },
                {
                    path: 'addEmployees',
                    name: 'Add Employees',
                    component: AddEmployees
                },
                {
                    path: 'wallet_connection',
                    name: 'Wallet',
                    component: WalletConnection
                },
                {
                    path: 'profileScreen',
                    name: 'Profile',
                    component: ProfileScreen
                }
            ]
        }
    ]
});
